import { useState } from 'react';

import { Dropdown } from '../../dropdown/dropdown';
import { recipeListingScreenGroupedByOptions } from '../utils';

export const RecipeSortFilter = ({ groupedBy, setGroupedBy }) => {
    const [show, setShow] = useState(false);

    return (
        <div className="recipes-sort-filter-container">
            <h4>Group/Sort Recipes By</h4>
            <Dropdown
                DropdownSelectorLeftContent={<span className="dropdown-label">{recipeListingScreenGroupedByOptions.find(({ id }) => id === groupedBy)?.label}</span>}
                dropdownOnClick={() => setShow(!show)}
                DropdownContent={recipeListingScreenGroupedByOptions.map(({ id, label }) => (
                    <li
                        key={id}
                        onClick={() => {
                            setGroupedBy(id);
                            setShow(false);
                        }}
                    >{label}</li>
                ))}
                onClickOutside={() => setShow(false)}
                show={show}
            />
        </div>
    )
}